<!--
    * @Description: 返回顶部
    * @Author: pliybird
    * @Date: 2022-01-04 00:44:26
 * @LastEditTime: 2023-07-20 13:45:24
 * @LastEditors: pliybird
    * @filePath: Do not edit
   -->
<template>
  <div>
    <div class="global-hover-box" :style="{ top: $i18n.locale === 'zh_CN' ? '70%' : '80%' }">
      <div class="feedback-box" v-if="$i18n.locale === 'zh_CN'">
        <div class="feedback-img-list">
          <div class="service_img center_img">
            <img class="icon_img" src="../../../assets/images/globalHover/img_01_earphone.png" alt="" />
            <div class="service_dialog dialog_txt">
              {{ $t('feedback.scrollTop.tab01') }}
              <div>
                <img class="service_dialog_img" :src="require('@/assets/images/home/qr_code.png')" alt="">
              </div>
            </div>
          </div>
          <div class="phone_img center_img">
            <img class="icon_img" src="../../../assets/images/globalHover/img_02_phone.png" alt="" />
            <div class="phone_dialog dialog_txt">
              {{ $t('feedback.scrollTop.tab02') }}
              <div class="dialog_gray">400-009-8870</div>
            </div>
          </div>
          <div class="form_img center_img" data-bs-toggle="modal" data-bs-target="#exampleModal">
            <img class="icon_img" src="../../../assets/images/globalHover/img_03_form.png" alt="" />
            <div class="form_dialog dialog_txt">
              {{ $t('feedback.scrollTop.tab03_1') }}
              <div class="dialog_gray">{{ $t('feedback.scrollTop.tab03_2') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="rn-back-top" @click="scrollToTop" :class="[visible ? 'd-inline' : 'd-none']">
        <!-- <img
          class="icon_img"
          src="../../../assets/images/globalHover/img_04_top.png"
          alt=""
        /> -->
        <Icon name="chevron-up" size="14" iconClass="" />
      </div>
    </div>
    <!-- 业务咨询 -->
    <FeedBack />
  </div>
</template>
  
<script>
import Icon from '../../icon/Icon'
import FeedBack from './FeedBack'

export default {
  name: 'ScrollTop',
  components: { Icon, FeedBack },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    toggleVisible() {
      const scrolled = document.documentElement.scrollTop;
      if (scrolled > 300) {
        this.visible = true;
      } else if (scrolled <= 300) {
        this.visible = false;
      }
    }
  },
  created() {
    window.addEventListener('scroll', this.toggleVisible);
  },
  mounted() {
    this.toggleVisible();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.toggleVisible);
  }
}
</script>